import Lib45 from "./lib/route.js";
import Macro46 from "./macro/route.js";
import UserProfile47 from "./UserProfile/route.js";

export default [
  Lib45,
  Macro46,
  UserProfile47,
];